import { render, staticRenderFns } from "./UserSettingsMenu.vue?vue&type=template&id=17fddb40&scoped=true&"
import script from "./UserSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./UserSettingsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fddb40",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17fddb40')) {
      api.createRecord('17fddb40', component.options)
    } else {
      api.reload('17fddb40', component.options)
    }
    module.hot.accept("./UserSettingsMenu.vue?vue&type=template&id=17fddb40&scoped=true&", function () {
      api.rerender('17fddb40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Users/UserSettingsMenu.vue"
export default component.exports